var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.source === 'font-awesome')?_c('FontAwesomeIcon',{class:_vm.computedClass,attrs:{"icon":[_vm.prefix, _vm.computedName]}}):(_vm.source === 'custom')?_c(_vm.customComponent,{tag:"Component",class:_vm.computedClass}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }